import { InventoryItem } from '@/hooks/useSupabaseStore';

interface Props { items: InventoryItem[]; }

const COLORS = ['#f59e0b', '#3b82f6', '#8b5cf6', '#10b981', '#ef4444'];

export default function CategoryChart({ items }: Props) {
  const activeItems = items.filter(i => i.status === 'pawned' || i.status === 'forfeited');
  const catMap: Record<string, { count: number; value: number }> = {};
  activeItems.forEach(i => {
    if (!catMap[i.category]) catMap[i.category] = { count: 0, value: 0 };
    catMap[i.category].count += 1;
    catMap[i.category].value += i.loanAmount;
  });
  const total = activeItems.reduce((s, i) => s + i.loanAmount, 0);
  const cats = Object.entries(catMap).map(([name, d], idx) => ({
    name, count: d.count, value: d.value,
    percentage: total > 0 ? Math.round((d.value / total) * 100) : 0,
    color: COLORS[idx % COLORS.length],
  }));

  return (
    <div className="bg-white rounded-2xl p-5">
      <h3 className="font-bold text-gray-800 text-base mb-4">Hàng Tồn Kho Theo Danh Mục</h3>
      <div className="flex items-center justify-center mb-5">
        <div className="relative w-36 h-36">
          <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90">
            {(() => {
              let offset = 0;
              return cats.map((cat) => {
                const dash = cat.percentage;
                const gap = 100 - dash;
                const el = (
                  <circle key={cat.name} cx="18" cy="18" r="15.9" fill="none"
                    stroke={cat.color} strokeWidth="3.5"
                    strokeDasharray={`${dash} ${gap}`} strokeDashoffset={-offset} strokeLinecap="round" />
                );
                offset += dash;
                return el;
              });
            })()}
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <p className="text-gray-800 font-bold text-lg">{activeItems.length}</p>
            <p className="text-gray-400 text-xs">tài sản</p>
          </div>
        </div>
      </div>
      <div className="space-y-2.5">
        {cats.map((cat) => (
          <div key={cat.name} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: cat.color }}></span>
              <span className="text-gray-600 text-xs">{cat.name}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-gray-400 text-xs">{cat.count} món</span>
              <span className="text-gray-800 text-xs font-semibold">{cat.percentage}%</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100">
        <div className="flex justify-between items-center">
          <span className="text-gray-500 text-xs">Tổng cho vay</span>
          <span className="text-gray-800 font-bold text-sm">{(total / 1000000).toFixed(1)}M đ</span>
        </div>
      </div>
    </div>
  );
}